/* eslint-disable no-constant-condition */
/* eslint-disable no-nested-ternary */
import React from 'react';

import './userlists.css';  // Update the import to .css
import Sidebar from '../Sidebar/Sidebar';
import Navbar from '../Navbar/Navbar';
import DataTable from '../DataTable/DataTable';
import AdminList from '../AdminList/AdminList';
import CropList from '../CropList/CropList';
import FarmList from '../FarmList/FarmList';

function Lists({ type }) {

    const renderContent = () => {
        switch (type) {
            case 'users':
                return <DataTable />;
            case 'admins':
                return <AdminList />;
            case 'crops':
                return <CropList />;
            case 'farms':
                return <FarmList />;
            
            default:
                return <CropList />;
        }
    };

    return (
        <div className="list_page">
            <div className="home_sidebar">
                <Sidebar />
            </div>

            <div className="list_page_main">
                <Navbar />

                {/* mui data table */}
                <div className="data_table">
                    

                    {renderContent()}
                </div>
            </div>
        </div>
    );
}

export default Lists;
